import { negativeToFixedError } from './browser.js'

export default async function getJavascriptData(opts) {
    const date = new Date(Date.UTC(2020, 11, 4, 3, 23, 16, 738));

    const hasIntl = typeof Intl !== 'undefined' && Intl && typeof Intl.DateTimeFormat === 'function';

    const data = {
        date: hasIntl
            ? {
                formatted: Intl.DateTimeFormat('ban', { dateStyle: 'full', timeStyle: 'long' }).format(date),
                hoursCycle: Intl.DateTimeFormat(void 0, { hour: 'numeric' }).resolvedOptions().hourCycle
            }
            : { formatted: null, hoursCycle: null },
        window: {
            innerWidth: window.innerWidth ?? null,
            innerHeight: window.innerHeight ?? null,
            outerWidth: window.outerWidth ?? null,
            outerHeight: window.outerHeight ?? null,
            devicePixelRatio: window.devicePixelRatio ?? null,
            screenX: window.screenX ?? null,
            screenY: window.screenY ?? null,
            scrollX: window.scrollX ?? null,
            scrollY: window.scrollY ?? null,
            visualViewportWidth: window.visualViewport?.width ?? null,
            visualViewportHeight: window.visualViewport?.height ?? null,
            visualViewportScale: window.visualViewport?.scale ?? null,
            documentClientWidth: document.documentElement?.clientWidth ?? null,
            documentClientHeight: document.documentElement?.clientHeight ?? null,
            documentClientWidthPrecise: document.documentElement?.getBoundingClientRect?.().width ?? null
        },
        screen: {
            width: screen.width ?? null,
            height: screen.height ?? null,
            aspectRatio: Math.max(screen.width ?? 0, screen.height ?? 0) / Math.min(screen.width ?? 1, screen.height ?? 1),
            availWidth: screen.availWidth ?? null,
            availHeight: screen.availHeight ?? null,
            availTop: screen.availTop ?? null,
            availLeft: screen.availLeft ?? null,
            colorDepth: screen.colorDepth ?? null,
            pixelDepth: screen.pixelDepth ?? null,
            isExtended: screen.isExtended ?? null,
            orientation: screen.orientation ?? null
        },
        audio: await getAudioAPI(),
        windowProps: getPrototype(window),
        documentProps: getPrototype(document),
        navigatorProps: getPrototype(navigator)
    };

    if (!opts || opts.battery !== false) data.battery = await getBattery();

    return data;
}


async function getBattery() {
    if (typeof navigator.getBattery === 'undefined') return false;

    let res = await navigator.getBattery();

    return {
        level: res?.level,
        charging: res?.charging,
        dischargingTime: res?.dischargingTime,
        chargingTime: res?.chargingTime
    }
}

function isChromiumOrFirefox() {
    const msg = negativeToFixedError();
    if (msg == null) return false;
    const len = msg.length;
    return len === 25 || len === 51;
}

function isMac() {
    return ['macos', 'macintel'].includes((navigator.platform ?? '').toLowerCase());
}

async function getAudioAPI() {
    let res = {};

    let ctx;
    if (isMac() && isChromiumOrFirefox()) {
        ctx = 
            window.OfflineAudioContext && new window.OfflineAudioContext(1, 1, 44100) || 
            window.webkitAudioContext && new window.webkitAudioContext();
    } else {
        ctx = 
            window.AudioContext && new window.AudioContext() || 
            window.webkitAudioContext && new window.webkitAudioContext();
    }


    if (!ctx) {
        return null;
    } else {
        let anCtx = ctx.createAnalyser();

        let attrs = ['channelCount', 'channelCountMode', 'channelInterpretation', 'fftSize', 'frequencyBinCount', 'maxDecibels', 'minDecibels', 'numberOfInputs', 'numberOfOutputs', 'smoothingTimeConstant'];

        for (let i=0; i<attrs.length; i++) {
            if (typeof anCtx[attrs[i]] !== 'undefined') {
                res[attrs[i]] = anCtx[attrs[i]];
            }
        }

        attrs = ['sampleRate', 'baseLatency'];

        for (let i=0; i<attrs.length; i++) {
            if (typeof ctx[attrs[i]] !== 'undefined') {
                res[attrs[i]] = ctx[attrs[i]];
            }
        }
    }

    return res;
}

function getPrototype(obj, res) {
    return void 0 === res && (res = []), null == Object.getPrototypeOf(obj) ? res : getPrototype(Object.getPrototypeOf(obj), res.concat(Object.getOwnPropertyNames(obj)))
}